import * as setup from 'setup';
import styled from 'styled-components';

export const IconButtonElement = styled.button`
    background: transparent;
    border: none;
    padding: 0;

    &:not(:disabled) {
        cursor: pointer;
    }

    &:disabled > svg > :first-child {
        fill: ${setup.colors.lightGrey};
    }
`;